<template>
    <v-dialog v-model="dialog2" persistent max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          >Add New
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Task</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form1"
            >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="task.task"
                  label="Task Name"
                  type="text"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                  <v-select
                  v-model="task.project_id"
                  :items="allprojects"
                  item-text="title"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="Project Name"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="task.assign_to"
                  :items="allusers"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="Assign To"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                  <v-select
                  v-model="task.priority"
                  :items="['Low','Medium','High']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Priority"
                  required
                ></v-select>
              </v-col>
               
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">Close</v-btn>
          <v-btn color="success darken-1" text @click="addtask1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
import sendMessage from '../apis/sendMessage.js';
  export default {
    data: function() {
      return {
        dialog2: false,
        task: {
            task : '',
            assign_to: '',
            priority: '',
            project_id: '',
            user_id: '',
            status: 0,
        },
      }
    },
    computed: {
      ...mapGetters(["allusers","currentuser",'allprojects']),
    },
    created() {
        this.task.user_id = this.currentuser.id;
    },
    methods:{
      ...mapActions(['addtask']),
      addtask1() {
        if(this.$refs.form1.validate())
        {
          this.task.user_id = this.currentuser.id;
          this.addtask(this.task).then(() => {
            let user = this.allusers.filter(product => product.id === this.task.assign_to);
            let project = this.allprojects.filter(product => product.id === this.task.project_id);
            let msg = `⭕️ ${this.task.task} <pre>\n</pre><pre>\n</pre> 💼 ${project[0].title} <pre>\n</pre><pre>\n</pre> 🧍 <a href="tg://user?id=${user[0].bot_id}">@${user[0].name}</a> by ${this.currentuser.name}`;
            sendMessage(msg);
          });
          this.dialog2 = false;
        }
      }
    }
  }
</script>